import { ApplicationQuery } from '../state/application/application.query';

/**
 * GlobalSearch Extensions Config.
 *
 * @param app Application Query.
 * @returns An observable GseApiConfig.
 */
export const gseApiConfigFactory = (app: ApplicationQuery) => app.gseConfig$;
